'use client';

import { useEffect, useState } from 'react';

import { formatRelativeDate } from '@/shared/utils/format-relative-date';

/**
 * Дата вида «Сегодня» / «Вчера» / «15 марта» / «15 марта 2022».
 * Считается только в браузере: результат зависит от текущего дня и часового
 * пояса пользователя, а HTML страницы может быть закеширован (ISR).
 */
export const RelativeDate = ({
  date,
  className,
}: {
  date: string;
  className?: string;
}) => {
  const [now, setNow] = useState<Date | null>(null);

  useEffect(() => {
    setNow(new Date());
  }, []);

  return (
    <time dateTime={date} className={className}>
      {now ? formatRelativeDate(date, now) : ' '}
    </time>
  );
};
